var _rect, _rect2, _rect3, _rect4, _rect5, _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImportCsvTwo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 80,
    viewBox: "0 0 109 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 109,
    height: 80,
    rx: 4,
    fill: "#F6F8FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 15,
    width: 47,
    height: 4,
    rx: 2,
    fill: "#CAD5FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 52,
    width: 89,
    height: 4,
    rx: 2,
    fill: "#CAD5FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 62,
    width: 89,
    height: 4,
    rx: 2,
    fill: "#CAD5FF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 25,
    width: 25,
    height: 4,
    rx: 2,
    fill: "#CAD5FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 24,
    r: 16,
    fill: "#CAD5FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 35,
    r: 11,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.866 29.1395C35.8083 29.1144 35.7424 29.0977 35.6764 29.081C35.6105 29.0643 35.5116 29.0476 35.4374 29.0308H35.4209C35.4126 29.0308 35.4126 29.0308 35.4044 29.0308C34.1514 28.847 33.0633 29.4989 32.7583 30.6273C32.4368 31.8309 33.1375 33.0763 34.3245 33.4023C34.3245 33.4023 34.3245 33.4023 34.3328 33.4023C34.3575 33.4106 34.3905 33.419 34.4234 33.4273C35.2478 33.7199 35.6764 34.6393 35.3879 35.4668C35.0994 36.3026 34.1926 36.7372 33.3765 36.4447C32.5604 36.1522 32.1235 35.2411 32.4121 34.4053C32.478 34.2214 32.5769 34.0458 32.7006 33.8954C32.7171 33.8703 32.7335 33.8536 32.7583 33.8369C33.0221 33.5611 33.0221 33.1264 32.7583 32.8506C32.4862 32.5831 32.0576 32.5831 31.7856 32.8506C31.7773 32.859 31.7773 32.859 31.7691 32.8673C31.7361 32.9008 31.7031 32.9425 31.6701 32.976C30.5985 34.2297 30.7386 36.1187 31.9669 37.2053C33.1952 38.2919 35.0664 38.1498 36.1381 36.9044C37.2097 35.6507 37.0696 33.7617 35.8413 32.6751C35.627 32.4828 35.3797 32.324 35.1159 32.207H35.1076C35.0335 32.1736 34.9593 32.1401 34.8768 32.1151C34.7862 32.0816 34.712 32.0649 34.679 32.0566C34.2256 31.9312 33.9618 31.4548 34.0855 30.9951C34.2256 30.4601 34.7779 30.3431 35.2066 30.4016C35.2643 30.41 35.3302 30.4267 35.3797 30.435C35.4044 30.4434 35.4291 30.4434 35.4456 30.4518C37.8692 31.2709 39.1881 33.9205 38.3803 36.3778C37.5724 38.8352 34.9675 40.1892 32.5439 39.3701C30.1204 38.551 28.8014 35.9014 29.601 33.444C29.972 32.3073 30.7551 31.3628 31.7938 30.7944C32.1235 30.6106 32.2554 30.1926 32.0741 29.85C31.8927 29.5156 31.4805 29.3819 31.1426 29.5658C28.2326 31.1622 27.1445 34.8566 28.7272 37.8071C29.4856 39.228 30.7634 40.2812 32.2884 40.7409C32.849 40.9081 33.4342 41 34.0195 41C35.0829 41 36.1298 40.7075 37.0448 40.1558C38.4792 39.3033 39.4931 37.8823 39.8558 36.2357C40.5236 33.1515 38.8172 30.1007 35.866 29.1395Z",
    fill: "#5864FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportCsvTwo);
export default __webpack_public_path__ + "static/media/import-csv-two.d5765b94d22f04aee2960b631ffd0488.svg";
export { ForwardRef as ReactComponent };